export const cdnUrl = process.env.NEXT_PUBLIC_CDN_URL || "";
export const imgCdnRoot = process.env.NEXT_PUBLIC_IMG_CDN_ROOT || "";
export const hostname = process.env.NEXT_PUBLIC_HOSTNAME || "";
